export const AUTH_EXTERNAL_USER = 'usuario_externo';
export const AUTH_AZURE = 'azure';
export const GRANT_TYPE_CODE = 'authorization_code';
export const GRANT_TYPE_PASSWORD = 'password';
export const CODE_CHALLENGE_METHOD = 'S256';
export const APLICACAO = 'freelancer';
